import InboundDiagram from './InboundDiagram';
export default InboundDiagram;
